/**
 * No-op in production builds; forwards to console.log otherwise.
 *
 * Use for verbose diagnostic logging (profile objects, MSAL account details,
 * chat activity payloads) that shouldn't ship to production browser consoles.
 * Does not replace console.warn/console.error — those indicate real failures
 * and should stay visible in every environment.
 */
export const devLog = process.env.NODE_ENV === "production" ? () => {} : (...args) => console.log(...args);
